import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Dashboard from './components/Dashboard';
import GoogleOAuthHandler from './components/GoogleOAuthHandler';
import Hero from './components/Hero';

const App = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const checkAuthStatus = () => {
      const authData = localStorage.getItem('auth');
      console.log('App checking auth status. LocalStorage:', authData);
      setIsAuthenticated(!!authData);
    };

    checkAuthStatus();

    // Listen for storage updates (e.g., when token is saved)
    window.addEventListener('storage', checkAuthStatus);

    return () => {
      window.removeEventListener('storage', checkAuthStatus);
    };
  }, []);

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Hero />} />
        <Route
          path="/dashboard"
          element={isAuthenticated ? <Dashboard /> : <Hero />}
        />
        <Route
          path="/assets/oauth/google/index.html"
          element={<GoogleOAuthHandler />}
        />
      </Routes>
    </Router>
  );
};

export default App;
